export const SERVER_BASE_URL = 'https://testserver2.outby.se/';
